(() => {
  const rootSelector = '[data-limited-offer]';
  const dropdownSelector = '[data-limited-offer-dropdown]';

  function setDropdownOpen(dropdown, open) {
    if (!dropdown) return;

    dropdown.classList.toggle('is-open', open);
    dropdown.querySelectorAll('[data-limited-offer-dropdown-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    const panel = dropdown.querySelector('[data-limited-offer-dropdown-panel]');
    if (panel) panel.hidden = !open;
  }

  function closeDropdowns(scope = document, except = null) {
    scope.querySelectorAll(dropdownSelector).forEach((dropdown) => {
      if (dropdown !== except) setDropdownOpen(dropdown, false);
    });
  }

  function syncDropdown(select, option, showSelectedLabel = false) {
    const dropdown = select?.closest(dropdownSelector);
    if (!dropdown || !option) return;

    dropdown.querySelectorAll('[data-limited-offer-option]').forEach((button) => {
      button.setAttribute('aria-selected', button.dataset.value === option.value ? 'true' : 'false');
    });

    if (showSelectedLabel) {
      dropdown.querySelectorAll('[data-limited-offer-dropdown-label]').forEach((label) => {
        label.textContent = option.textContent.trim();
      });
    }
  }

  function applyVariant(root, option) {
    if (!root || !option) return;

    const available = option.dataset.available === 'true';
    const input = root.querySelector('[data-limited-offer-variant-input]');
    const submit = root.querySelector('[data-limited-offer-submit]');
    const price = root.querySelector('[data-limited-offer-price]');
    const compare = root.querySelector('[data-limited-offer-compare]');
    const image = root.querySelector('[data-limited-offer-image]');

    if (input) {
      input.value = option.value;
      input.disabled = !available;
    }

    if (submit) submit.disabled = !available;
    if (price) price.textContent = option.dataset.priceText || '';
    if (compare) {
      compare.textContent = option.dataset.compareText || '';
      compare.hidden = !option.dataset.compareText;
    }

    if (image && option.dataset.imageUrl) {
      image.src = option.dataset.imageUrl;
      image.alt = option.dataset.imageAlt || image.alt;
    }
  }

  function initLimitedOffer(root) {
    if (!root || root.dataset.limitedOfferReady === 'true') return;

    root.dataset.limitedOfferReady = 'true';
    root.querySelectorAll('[data-limited-offer-variant]').forEach((select) => {
      applyVariant(root, select.selectedOptions[0]);
      syncDropdown(select, select.selectedOptions[0], false);
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(rootSelector).forEach(initLimitedOffer);
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-limited-offer-variant]');
    if (!select) return;

    const root = select.closest(rootSelector);
    applyVariant(root, select.selectedOptions[0]);
    syncDropdown(select, select.selectedOptions[0], select.dataset.limitedOfferShowSelected === 'true');
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest(dropdownSelector)) closeDropdowns();

    const root = event.target.closest(rootSelector);
    if (!root) return;

    initLimitedOffer(root);

    const optionButton = event.target.closest('[data-limited-offer-option]');
    if (optionButton && root.contains(optionButton)) {
      const dropdown = optionButton.closest(dropdownSelector);
      const select = dropdown?.querySelector('[data-limited-offer-variant]');

      if (select && optionButton.dataset.value) {
        event.preventDefault();
        select.value = optionButton.dataset.value;
        select.dataset.limitedOfferShowSelected = 'true';
        select.dispatchEvent(new Event('change', { bubbles: true }));
        setDropdownOpen(dropdown, false);
      }
      return;
    }

    const dropdownTrigger = event.target.closest('[data-limited-offer-dropdown-trigger]');
    if (dropdownTrigger && root.contains(dropdownTrigger)) {
      const dropdown = dropdownTrigger.closest(dropdownSelector);
      const shouldOpen = !dropdown.classList.contains('is-open');

      event.preventDefault();
      closeDropdowns(root, dropdown);
      setDropdownOpen(dropdown, shouldOpen);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDropdowns();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
